export const REACT_APP_CONTAINER_ID = 'root';
export const REACT_APP_PRELOADED_STATE_CONTAINER_ID = '__APP_PRELOADED_STATE__';
export const REACT_APP_SSR_STATE_CONTAINER_ID = '__APP_SSR_STATE__';
